import React, {useState, useEffect} from 'react';
import CommunityWizardBody from './CommunityWizardBody';
import Api from '../../../api/SMPFetchHelper';
import {ObjectTypes} from '../../../api/consts';
import {useSMCErrorHandler} from '../../../utils/errorUtils';
import SMCModal from '../../../components/core/SMCModal';
import {useTranslation} from 'react-i18next';
import {CommunityCreateSchema} from '../../../api/DBSchema/Community';
import {useIsMountedRef} from '../../../utils/hooks';

function CommunityWizard({
    isOpen,
    onRequestClose,
    onSuccess
}) {
    const { t } = useTranslation();
    const { getErrorMessage } = useSMCErrorHandler();
    const isMountedRef = useIsMountedRef();

    const [isLoading, setIsLoading] = useState(false);
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');

    const onFinish = async () => {
        const createCommunityRequestObj = {
            [CommunityCreateSchema.name]: name,
            [CommunityCreateSchema.description]: description,
        }
        setIsLoading(true);
        Api.createObject(ObjectTypes.COMMUNITY, createCommunityRequestObj)
        .then(() => {
            if (isMountedRef.current) {
                onSuccess(name);
            }
        })
        .catch (e => {
            if (isMountedRef.current) {
                const errorMessage = getErrorMessage(e);
                alert(errorMessage);
            }
        })
        .finally(() => {
            if (isMountedRef.current) {
                setIsLoading(false);
            }
        });
    }

    // Reset to defaults on every open
    useEffect(() => {
        if (isOpen) {
            setName('');
            setDescription('');
        }
    }, [isOpen]);

    const wizardVars = {
        name, setName,
        description, setDescription,
    }

    return (
        <SMCModal
            title={t('SMP.COMMUNITY.CREATE_NEW')}
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            width={610}
            height={600}
            loading={isLoading}
        >
            <CommunityWizardBody
                onFinish={onFinish}
                onCancel={onRequestClose}
                wizardVars={wizardVars}
            />
        </SMCModal>
    );
}

export default CommunityWizard;